
/* eslint-disable react/jsx-key */

import { saveAs } from "file-saver"
import { t } from "i18next"
import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState
} from "react"
import { downloadExcel } from "react-export-table-to-excel"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"
import {
    useAsyncDebounce,
    useFilters,
    useGlobalFilter,
    useRowSelect,
    useSortBy,
    useTable
} from "react-table"
import * as XLSX from "xlsx"

import ToggleButton from "./ToggleButton"
import close from "../../assets/common/close.svg"
import eyeIcon from "../../assets/common/eye.svg"
import print from "../../assets/common/print.svg"
import downIcon from "../../assets/common/sort_down.svg"
import upIcon from "../../assets/common/sort_up.svg"
import deleteIcon from "../../assets/Hub_Icons/delete.svg"
import downloadIcon from "../../assets/Hub_Icons/download.svg"
import editIcon from "../../assets/Hub_Icons/edit.svg"
import filterIcon from "../../assets/Hub_Icons/filter.svg"
import copyIcon from "../../assets/Hub_Icons/Interactive-icon.svg"
import searchIcon from "../../assets/Hub_Icons/search.svg"
import sortIcon from "../../assets/Hub_Icons/sort.svg"
import CustomDropdown from "../../components/Common/Form/Dropdown"
import Dropdown from "../../components/Common/Form/DropdownWithSetValueSupport"
import Loader from "../../components/Common/Loader/loader"
import { convertDateTimeByFormat, extractPlainText, isValidRichText, textLineClamp } from "../../utils/utils.js"
import CustomToolTip from "../Common/CustomToolTip/index.js"
import CustomDatePicker from "../Common/Form/DatePicker/index.js"
import DropDownButton from "../Common/Form/DropdownButton/index.js"
import { ErrorField } from "../Common/Form/Error/index.js"
import { InputBox } from "../Common/Form/InputBox/InputBox"
import Language from "../Common/Language"
import RichTextEditor from "../Common/RichTextEditor"
import LanguageSelector from "../LanguageSelector"

export  const GlobalFilter = ({
    globalFilter,
    setGlobalFilter,
    isCustomSearch,
    onCustomSearch,
    customsearchtext,
    searchWrapperClass,
    clearcustomsearchtext,
    setclearCustomsearchtext = () => {},
    ...props
}) => {
    const [searchtxt, setSearchtxt] = useState( globalFilter)
    const onChange = useAsyncDebounce((searchtxt) => {
        if (isCustomSearch) {
            if (customsearchtext?.trim() != "" && searchtxt?.trim() == "") {
                onCustomSearch(searchtxt)
            }
        } else {
            setGlobalFilter(searchtxt || undefined)
        }
    }, 200)

    useEffect(() => {
        if (isCustomSearch && customsearchtext?.trim() != "") {
            setSearchtxt(customsearchtext)
        }
        if(!customsearchtext){
            setSearchtxt("")
        }
    }, [customsearchtext])
    return (
        <div className="relative">
            <input
                type="Search"
                className= { `${searchWrapperClass || ""} border-lightGray border 
                    rounded-[57px] h-9 px-4 pr-12 outline-0 placeholder-secondary-50 
                    fontSize-sm focus:outline-none focus:ring-0 focus:border-primary-100 
                    focus:bg-lightSkyblue hover:border-primary-100` }
                placeholder={ props?.placeHolder ? `${t("search.searchBy")}...` : t("common.search") }
                value={ clearcustomsearchtext ? "" :  (searchtxt || "") }
                onChange={ (e) => {  
                    setclearCustomsearchtext(false)                  
                    setSearchtxt(e.target.value)
                    onChange(e.target.value)
                } }
                onKeyDown={ (e) => {
                    if (e.key === "Enter") {
                        if (isCustomSearch) {
                            onCustomSearch(searchtxt || "")
                        } else {
                            setGlobalFilter(searchtxt || undefined)
                        }
                    }
                } }
                data-tooltip-id="tooltip-1"
                data-tooltip-html={ props?.placeHolder ? props?.placeHolder : t("common.search") }
            />
            { props?.placeHolder && <CustomToolTip index="1"  isInputBox={ true }/> }
            <button
                type="submit"
                className="absolute right-4 h-9 top-0 flex items-center justify-center"
                onClick={ () =>
                    isCustomSearch && searchtxt
                        ? onCustomSearch(searchtxt)
                        : setGlobalFilter(searchtxt)
                }
            >
                <img alt="search" src={ searchIcon } className="" height={ "16px" } width={ "16px" } />
            </button>
        </div>
    )
}

const Table = ({
    title,
    titleDetails,
    subDetails,
    searchFilterSectionBottom = false,
    lastColumnWidth = false,
    subTitle,
    warrantyTableDetailTopTab,
    advanceSearchTopSearch,
    columns,
    data,
    translateFeature,
    tableMinHeight,
    globalLanguageChange,
    downloadFeature,
    checkBoxFeature,
    downloadData,
    addNewFeature,
    customButtonFeature,
    customButton,
    filterFeature,
    onHandleToogleClick,
    isStickyColumns,
    isStickyColumnsFirst2,
    setCurrentLanguages,
    isJsondownload,
    getDownloadData,
    isDeleteRow,
    isCountryHubAssociation,
    isCustomSearch,
    onCustomSearch,
    customsearchtext,
    status,
    loader,
    disableSearch,
    sortFeature,
    handleFilterClick,
    permissionDetails,
    module,
    isStickyColumnslast2,
    isStickyColumnslast3,
    isStickyColumnlast,
    isButonURL,
    isFilteredValue,
    languageChangeHandler,
    isCustomLanguageSelector,
    copyFeature,
    renderKey,
    isDropdownButton,
    dropdownMenus,
    disableHeader,
    uploadButtonTitle,
    uploadFeature,
    isUploadFeatureDisabled,
    isFullTableEdit,
    editableRowId,
    filterDropdown,
    filterDropdownProps,
    addNewLinkFeature,
    addNewLinkFeatureProps,
    tbaleWithTopImageData,
    bigImageUrls,
    imageData,
    isCustomHeading,
    setReversePositionNumber = () => {},
    reversePositionNumber,
    customHeader,
    drawingImage,
    isEditHotSpot,
    isEnabledHotSpotEdit = true,
    viewPosition,
    isPaginationEnabled = true,
    action,
    showNoRecords = false,
    checkBoxFilter,
    customFilters,
    assignedPartCheckboxRender,
    uploadBtnRender,
    customDropdownsRender,
    rightPosition133,
    warrantyTableTopSelect,
    partsTopDropDownPrice,
    ispartsTopDropdown,
    addNewFeatureDisabled,
    workListApproval,
    warrantyTableDetailTopButton,
    warrantyTableTicketFilterButton,
    allSecondaryCheckCompnent,
    expandedRows,
    enableCustomSort,
    onClickSort,
    ticketDetailsFilter =[],
    rejectFeature = false,
    salesOrgFilter = false,
    salesOrgOptions = [],
    selectedSalesOrg,
    salesOrgFilterHandler,
    addNewButton,
    addNewButtonText,
    addNewButtonhandler,
    translatePermissionDetails,
    right162 = false,
    right186 = false,
    right73 = false,
    right183th= false,
    isExport = false,
    customeMessageNoRecord= false,
    getExportDownload,
    clearcustomsearchtext,
    setclearCustomsearchtext,
    csvDownloadFeature = false,
    handleDownloadPerformCSVExcel,
    isSearchButtonClicked = true, // DON'T MODIFY THIS FLAG PASS FROM COMPONENT 
    ...props
}) => {
    const { t } = useTranslation()
    const [sortValue, setSortValue] = useState("")
    const [editableRowIndex, setEditableRowIndex] = useState(null)
    const scrollRef =useRef(null)
    const globalSelectedLanguage = localStorage.getItem("selectedLanguageId")
    const defaultLangaugeId = localStorage.getItem("defaultLanguage_id")
    const [sortBy, setSortBy] = useState({})
  
    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({ behavior: "smooth", block: "center" })
        }
    }, [viewPosition?.position_number])
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        setGlobalFilter,
        state,
        prepareRow,
        selectedFlatRows
    } = useTable(
        {
            columns: columns || [],
            data: data || [],
            editableRowIndex,
            setEditableRowIndex,
            manualSortBy: enableCustomSort ? true : false, // Tell the table that we'll handle sorting manually
            disableMultiSort: true // Optionally disable multi-sort,
            
        },
        useFilters,
        useGlobalFilter,
        useSortBy,
        useRowSelect,
        (hooks) => {
            if (checkBoxFeature || props.isCheckBoxEnabled) {
                hooks.visibleColumns.push((columns) => [
                    {
                        id: "selection",
                        Header: ({ getToggleAllRowsSelectedProps }) => (
                            <div className="text-sm font-bold text-primary-50">
                                <IndeterminateCheckbox
                                    { ...getToggleAllRowsSelectedProps() }
                                    label={ props?.checkboxlabel }
                                />
                            </div>
                        ),
                        Cell: ({ row }) => (
                            <div>
                                <IndeterminateCheckbox
                                    { ...row.getToggleRowSelectedProps() }
                                    value={ row.original.id }
                                />
                            </div>
                        )
                    },
                    ...columns
                ])
            }
        }
    )

    const IndeterminateCheckbox = forwardRef(
        ({ indeterminate, ...rest }, ref) => {
            const defaultRef = useRef()
            let resolvedRef = ref || defaultRef
            useEffect(() => {
                resolvedRef.current.indeterminate = indeterminate
            }, [resolvedRef, indeterminate])
            return (
                <>
                    <div className="flex items-center gap-1">
                        <div className="relative cursor-pointer  select-none w-[18px] h-[18px] custom-checkbox">
                            <input
                                type="checkbox"
                                className={ "peer w-[18px] h-[18px] absolute opacity-0 z-[2]" }
                                ref={ resolvedRef }
                                { ...rest }
                            />
                            <span
                                className={ `checkmark absolute h-[18px] w-[18px] bg-white 
                                    border rounded-[4px] border-primary-50 z-[1] after:absolute 
                                    after:hiddent after:content-[''] after:w-[6px] after:h-[12px] 
                                    after:rotate-45  after:border-b-[2px]  after:border-r-[2px] 
                                    after:border-white after:left-[5px] after:top-[1px] ${
                rest?.checked ? "after:block !bg-primary-50" : ""}` }
                            ></span>
                        </div>
                        { rest?.label && (
                            <label className="relative top-[3px] left-[5px]">
                                { rest.label }
                            </label>
                        ) }
                    </div>
                </>
            )
        }
    )
    
    const renderIcon = (imageIcon) => {
        const defaultIcon = editIcon
        const icons = {
            eye: eyeIcon,
            pencil: editIcon
        }
    
        const iconSrc = icons[imageIcon] || defaultIcon
    
        return (
            <img
                src={ iconSrc }
                height="14px"
                width="14px"
                alt="Icon"
                title="Icon"
            />
        )
    }
    
    const handleSortChange = (columnId) => {
        if(enableCustomSort){
            let orderBy = ""
            setSortBy((prevSortBy)=>{
                const isSameColumn = prevSortBy.column === columnId
                orderBy = isSameColumn && prevSortBy.order === "ASC" ? "DESC" :"ASC"
                onClickSort(columnId,orderBy)
                return {
                    column : columnId,
                    order : orderBy
                }
            })
        }
        else return
    }

    const renderDataTable = (row, cell, index) => {
      
        let isEditable= false
        if(isFullTableEdit){
            isEditable = true
        }
        else{
            isEditable = editableRowId === row.index
        }
        const cellColumn = cell?.column
        switch (cell.column.type) {
        case "toogle": {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        "px-4 border-b border-secondary-300 text-sm text-secondary-50 py-2" +
              (isStickyColumns === true
                  ? index === 0
                      ? " left-0 sticky w-100 bg-white"
                      : row.cells.length - 1 === index
                          ? " right-0 sticky w-101 bg-white"
                          : ""
                  : "")
                    }
                >
                    <div className="flex items-center flex-row-reverse justify-end gap-4">
                        { cell.render("Cell") }
                        <ToggleButton
                            value={ cell.value }
                            row={ row }
                            onHandleChange={ onHandleToogleClick }
                            disabled = { permissionDetails?._update ? false : true }
                        />
                    </div>
                </td>
            )
        }
        case "toogleCustom": {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        "px-4 border-b border-secondary-300 text-sm text-secondary-50 py-2" +
              (isStickyColumns === true
                  ? index === 0
                      ? " left-0 sticky w-100 bg-white"
                      : row.cells.length - 1 === index
                          ? " right-0 sticky w-101 bg-white"
                          : ""
                  : "")
                    }
                >
                    <div className="flex items-center flex-row-reverse justify-end gap-4">
                        { cell.render("Cell") }
                        <ToggleButton
                            value={ cell.value }
                            row={ row }
                            onHandleChange={ onHandleToogleClick }
                            disabled = { cell?.row?.original?.status !== "COMPLETE" ? false : true }
                        />
                    </div>
                </td>
            )
        }
        case "link": {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        "px-4 border-b border-secondary-300 text-sm text-secondary-50 py-2 " +
                        (!workListApproval? "text-left" : "") +
              (isStickyColumns === true
                  ? index === 0
                      ? " left-0 sticky w-100 bg-white"
                      : row.cells.length - 1 === index
                          ? " right-0 sticky w-101 bg-white"
                          : ""
                  : "")
                    }
                >
                    { cell.render("Cell") }
                    {
                        isEditable && action?.create ?
                            <></>:
                            <NavLink
                                onClick={ () => cell.column.onActionClick(row.original) }
                                className="nav-link text-sm text-primary-100 underline underline-offset-4"
                            >
                                { cell?.column?.linkTitle?t(cell?.column?.linkTitle):
                                    t("Approvals.viewDetailsApproval") }
                            </NavLink>
                    }
                </td>
            )
        }
        case "status": {
            return (
                <td
                    className={
                        "font-normal text-sm text-secondary-50 border-b border-secondary-300 text-left py-1 " +
              (isStickyColumns === true
                  ? index === 0
                      ? " left-0 sticky w-100 bg-white "
                      : row.cells.length - 1 === index
                          ? " right-0  w-101 bg-white "
                          : ""
                  : "")  + (isStickyColumnslast2 && (((row.cells.length - 1 === index 
                    || row.cells.length - 2 === index)  
                  && " right-0 sticky min-w-101 border-l px-4 border-gray bg-white ") 
                    + (row.cells.length - 2 === index 
                        &&  (lastColumnWidth ? `  ${lastColumnWidth} ` : " right-[81px] ") ) ))
                          + (isStickyColumnslast3 && (((row.cells.length - 1 === index 
                            || row.cells.length - 2 === index || row.cells.length - 3 === index)  
                            && " right-0 sticky min-w-101 px-4  bg-white   ") 
                            + (row.cells.length - 3 === index && " right-[183px]  border-l  border-gray ") 
                            + (row.cells.length - 2 === index && " right-[81px] ") ))
                          + (isStickyColumnlast && (((row.cells.length - 1 === index)  
                          && " right-0 sticky border-l px-4 border-gray bg-white ") 
                          + (row.cells.length - 1 === index && " ") ))
                    }
                    { ...cell.getCellProps() }
                >
                    <span
                        className={
                            "flex p-[8px] text-xs justify-center items-center gap-[10px]  pb-[4px] flex-1 rounded-md " +
                (cell?.value === "Approved" || cell?.value === true || cell?.value === t("common.ACTIVE") 
                    ? "bg-greenlight text-xs max-w-24 w-full inline-block text-center "
                    : cell?.value === "Pending" || cell?.value === false
                        ? "bg-greenyellow text-xs max-w-24 w-full inline-block text-center  "
                        : "bg-lightred text-xs max-w-24 w-full inline-block text-center ")
                        }
                    >
                        { cell.render("Cell") }
                    </span>
                </td>
            )
        }
        case "delete": {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        "px-4 border-b border-secondary-300 text-sm text-secondary-50 bg-white text-right " +
              (isStickyColumns === true
                  ? index === 0
                      ? " left-0 sticky bg-white"
                      : row.cells.length - 1 === index
                          ? " right-0 sticky w-101 bg-white "
                          : ""
                  : "")  + (isStickyColumnslast2 && (((row.cells.length - 1 === index 
                    || row.cells.length - 2 === index)  && " right-0 sticky w-101 bg-lightSkyblue ") 
                    + (row.cells.length - 2 === index && " border-l border-gray " (lastColumnWidth 
                        ? `  ${lastColumnWidth} ` : " right-[81px] ")) ))
                  + (isStickyColumnslast3 && (((row.cells.length - 1 === index 
                    || row.cells.length - 2 === index || row.cells.length - 3 === index)  
                    && " right-0 sticky w-101 bg-white ") + (row.cells.length - 3 === index 
                        && " border-l border-gray right-[183px] ") ))
                  + (isStickyColumnlast && (((row.cells.length - 1 === index)  
                  && " right-0 sticky border-l px-4 border-gray bg-white ") 
                  + (row.cells.length - 1 === index && " ") ))
                    }
                >
                    <div className="flex justify-end">
                        <button
                            className="shrink-0 p-2 rounded-full hover:border-0 
                            hover:bg-primary-150 transition-transform transform hover:scale-110"
                            onClick={ () => cell.column.onActionDeleteClick(row.original) }
                        >
                            <img
                                alt="delete record"
                                src={ deleteIcon }
                                className=""
                                height={ "14px" }
                                width={ "14px" }
                            />
                        </button>
                    </div>
                </td>
            )
        }
        case "edit": {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        "px-4 border-b border-secondary-300 text-sm text-secondary-50 bg-white text-right " +
              (isStickyColumns === true
                  ? index === 0
                      ? " left-0 sticky bg-white"
                      : row.cells.length - 1 === index
                          ? " right-0 sticky w-101 bg-white "
                          : ""
                  : "")  + (isStickyColumnslast2 && (((row.cells.length - 1 === index 
                    || row.cells.length - 2 === index)  && " right-0 sticky w-101 bg-lightSkyblue ") 
                    + (row.cells.length - 2 === index && " border-l border-gray  " (lastColumnWidth 
                        ? `  ${lastColumnWidth} ` : " right-[81px] ")) ))
                  + (isStickyColumnslast3 && (((row.cells.length - 1 === index 
                    || row.cells.length - 2 === index || row.cells.length - 3 === index)  
                    && " right-0 sticky w-101 bg-white ") + (row.cells.length - 3 === index 
                        && " border-l border-gray right-[183px] ") ))
                  + (isStickyColumnlast && (((row.cells.length - 1 === index)  
                  && " right-0 sticky border-l px-4 border-gray bg-white ") + (row.cells.length - 1 === index && " ") ))
                    }
                >
                    {
                        (module === "priceList") ? (
                            <>
                                {
                                    (permissionDetails?._update && row.original?.is_edit_delete && row.original?.status !== "Pending") && 
                                        <button
                                            onClick={ () => cell.column.onActionClick(row.original) }
                                            className="shrink-0 p-2 rounded-full hover:border-0
                        hover:bg-primary-150 transition-transform transform hover:scale-110"
                                        >
                                            <img
                                                src={ editIcon }
                                                height="14px"
                                                width="14px"
                                                alt="Edit"
                                                title="Edit"
                                            />
                                        </button>
                                }
                                {
                                    (permissionDetails?._delete && row.original?.is_edit_delete && row.original?.status !== "Pending") && 
                                        <button
                                            onClick={ () => cell.column.onActionDeleteClick(row.original) }
                                            className="shrink-0 p-2 rounded-full hover:border-0
                hover:bg-primary-150 transition-transform transform hover:scale-110"
                                        >
                                            <img
                                                src={ deleteIcon }
                                                height="14px"
                                                width="14px"
                                                alt="Delete"
                                                title="Delete"
                                            />
                                        </button>
                                }
                                {
                                    (row.original.version === 0 && row.original.status === "Rejected") && (
                                        <button
                                            onClick={ () => cell.column.onViewClick(row.original) }
                                            className="shrink-0 p-2 rounded-full hover:border-0 
                        hover:bg-primary-150 transition-transform transform hover:scale-110"
                                        >
                                            <img
                                                src={ eyeIcon }
                                                height="14px"
                                                width="14px"
                                                alt="View"
                                                title="View"
                                            />
                                        </button> )
                                }
                                
                            </>
                        ) : 
                    
                            (
                                <div className="flex justify-end">
                                    <>
                                        {
                                            (row.original.version ===  0 && row.original.status === "Rejected") ? (
                                                <button
                                                    onClick={ () => cell.column.onViewClick(row.original) }
                                                    className="shrink-0 p-2 rounded-full hover:border-0 
                                hover:bg-primary-150 transition-transform transform hover:scale-110"
                                                >
                                                    <img
                                                        src={ eyeIcon }
                                                        height="14px"
                                                        width="14px"
                                                        alt="View"
                                                        title="View"
                                                    />
                                                </button> ) :
                                                ((module === "hubContinent" ||
                                            module === "countryConfig" ||
                                            module === "hubRegionalContinents" ||
                                            module === "hubSubContinent" ||
                                            module === "order_min_max") &&
                                        !row?.original?.is_editable ? (<> </>) : 
                                                    ((permissionDetails?._update || translatePermissionDetails._read) && (
                                                        <>
                                                            <button
                                                                onClick={ () => cell.column.onActionClick(row.original) }
                                                                className="shrink-0 p-2 rounded-full hover:border-0
                                                 hover:bg-primary-150 transition-transform transform hover:scale-110"
                                                            >
                                                                { renderIcon(cell?.column?.imageIcon) }

                                                                { /* <img
                                                        src={ editIcon }
                                                        height="14px"
                                                        width="14px"
                                                        alt="Edit"
                                                        title="Edit"
                                                    /> */ }
                                                            </button>
                                                            { copyFeature && <button
                                                                onClick={ () => cell.column.onCopyClick(row.original) }
                                                                className="shrink-0 p-1 rounded-full hover:border-0
                                                 hover:bg-primary-150 transition-transform transform hover:scale-110"
                                                            >
                                                                <img
                                                                    src={ copyIcon }
                                                                    height="14px"
                                                                    width="14px"
                                                                    alt="Copy"
                                                                    title="Copy"
                                                                />
                                                            </button> }
                                                        </>
                                                    )
                                                    )
                                                ) 
                                        }
                                    </>

                                    { isDeleteRow && permissionDetails?._delete && (
                                        <button
                                            className="shrink-0 p-2 rounded-full hover:border-0 
                                hover:bg-primary-150 transition-transform transform hover:scale-110"
                                            onClick={ () => cell.column.onActionDeleteClick(row.original) }
                                        >
                                            <img
                                                alt="delete record"
                                                src={ deleteIcon }
                                                className=""
                                                height={ "12px" }
                                                width={ "12px" }
                                                title="Delete"
                                            />
                                        </button>
                                    ) }
                                </div>)
                    }
                    <div
                        className={
                            "border-[#CED0D6] absolute top-0 h-fill-available" +
                (isStickyColumns === true
                    ? index === 0
                        ? " border-r right-0 "
                        : row.cells.length - 1 === index
                            ? " border-l left-0 "
                            : ""
                    : "")
                        }
                    ></div>
                </td>
            )
        }
        case "inLineEdit" : {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        "px-4 border-b border-secondary-300 text-sm text-secondary-50 bg-white text-right " +
              (isStickyColumns === true
                  ? index === 0
                      ? " left-0 sticky bg-white"
                      : row.cells.length - 1 === index
                          ? " right-0 sticky w-101 bg-white "
                          : ""
                  : "")  + (isStickyColumnslast2 && (((row.cells.length - 1 === index 
                    || row.cells.length - 2 === index)  && " right-0 sticky w-101 bg-lightSkyblue ") 
                    + (row.cells.length - 2 === index && " border-l border-gray  " (lastColumnWidth 
                        ? `  ${lastColumnWidth} ` : " right-[81px] ")) ))
                  + (isStickyColumnslast3 && (((row.cells.length - 1 === index 
                    || row.cells.length - 2 === index || row.cells.length - 3 === index)  
                    && " right-0 sticky w-101 bg-white ") + (row.cells.length - 3 === index 
                        && " border-l border-gray right-[183px] ") ))
                  + (isStickyColumnlast && (((row.cells.length - 1 === index)  
                  && " right-0 sticky border-l px-4 border-gray bg-white ") 
                  + (row.cells.length - 1 === index && " ") ))
                    }
                >
                    <div className="flex justify-end">
                        <>
                            {
                                <>
                                    { isEditable ?
                                        <>
                                            <div>
                                                <NavLink
                                                    onClick={ () => cell?.column?.onSaveClick() }
                                                    className="nav-link text-sm text-primary-100"
                                                >
                                                    { t("Pricing.save") }
                                                </NavLink>

                                            </div>
                                            <div className="pt-0.5 pl-4">
                                                <button onClick={ () => cell?.column?.onCloseClick() } 
                                                    className="toast-close-btn h-4 w-4 ">
                                                    <img src={ close } alt="close" />
                                                </button>
                                            </div>
                                        </>
                                        :  
                                        <>
                                            { permissionDetails?._update && <button
                                                onClick={ () => cell?.column?.onActionClick(row) }
                                                className="shrink-0 p-2 rounded-full hover:border-0 
                                                hover:bg-primary-150 transition-transform transform hover:scale-110"
                                                disabled={ action?.edit || action?.create ? true :false }
                                            >
                                                <img
                                                    src={ editIcon }
                                                    height="14px"
                                                    width="14px"
                                                    alt="Edit"
                                                    title="Edit"
                                                />
                                            </button> }
                                            { cell?.column?.isDeleteRowInLine && permissionDetails?._delete && (
                                                <button
                                                    className="shrink-0 p-2 rounded-full hover:border-0 
                                                    hover:bg-primary-150 transition-transform transform hover:scale-110"
                                                    onClick={ () => cell?.column?.onDeleteClick(row?.original) }
                                                    disabled={ action?.edit || action?.create ? true :false }
                                                >
                                                    <img
                                                        alt="delete record"
                                                        src={ deleteIcon }
                                                        className=""
                                                        height={ "14px" }
                                                        width={ "14px" }
                                                        title="Delete"
                                                    />
                                                </button>
                                            ) }
                                        </>
                                    } 
                                </>
                                // )
                            }
                        </>
                    </div>
                    <div
                        className={
                            "border-[#CED0D6] absolute top-0 h-fill-available" +
                (isStickyColumns === true
                    ? index === 0
                        ? " border-r right-0 "
                        : row.cells.length - 1 === index
                            ? " border-l left-0 "
                            : ""
                    : "")
                        }
                    ></div>
                </td>
            )
        }
        case "dropdown" : {
            return(
                <td
                    { ...cell.getCellProps() }
                    className={ 
                        "px-4 border-b border-secondary-300 text-sm text-secondary-50 bg-white  " +
              (isStickyColumns === true
                  ? index === 0
                      ? " left-0 sticky bg-white"
                      : row.cells.length - 1 === index
                          ? " right-0 sticky w-101 bg-white "
                          : ""
                  : "")  + (isStickyColumnslast2 && (((row.cells.length - 1 === index 
                    || row.cells.length - 2 === index)  && " right-0 sticky w-101 bg-lightSkyblue ") 
                    + (row.cells.length - 2 === index && " border-l border-gray  " (lastColumnWidth 
                        ? `  ${lastColumnWidth} ` : " right-[81px] ")) ))
                  + (isStickyColumnslast3 && (((row.cells.length - 1 === index 
                    || row.cells.length - 2 === index || row.cells.length - 3 === index)  
                    && " right-0 sticky w-101 bg-white ") + (row.cells.length - 3 === index 
                        && " border-l border-gray right-[183px] ") ))
                  + (isStickyColumnlast && (((row.cells.length - 1 === index)  
                  && " right-0 sticky border-l px-4 border-gray bg-white ") 
                  + (row.cells.length - 1 === index && " ") )) + (editableRowId?" w-3.5 ":"")
                    }
                >
                    { isEditable ? 
                        <div className={ ` justify-end min-w-[100px] 
                        ${cellColumn?.errors?.[cellColumn?.id]? "block" : "flex"}` }>
                            <CustomDropdown
                                placeholder={ t(cellColumn?.Header) }
                                defaultValue={ cellColumn?.value }
                                options={ cellColumn?.getOptions ? cellColumn?.getOptions() : [] }
                                name={ cellColumn?.id }
                                changeHandler={ (e) => cellColumn?.onChange(e,row) }
                                errorData={ cellColumn?.errors }
                                isRequired={ cellColumn?.isRequired ? cellColumn?.isRequired : false }
                                isMulti={ false }
                                disabled={ false }
                                menuPlacement={ cellColumn?.menuPlacement }
                                isValueSelect={ true }
                                dataTestId={ cellColumn?.accessor }
                                className={ "w-40" }
                                labelIsRequired={ cellColumn?.labelIsRequired }
                            />
                        </div>: 
                        <>
                            { cell.render("Cell") }
                            <div
                                className={
                                    "border-[#CED0D6] absolute top-0 h-fill-available" +
                                (isStickyColumns === true
                                    ? index === 0
                                        ? " border-r right-0 "
                                        : row.cells.length - 1 === index
                                            ? " border-l left-0 "
                                            : ""
                                    : "") 
                                }
                            ></div>
                        </>
                    }
                </td>
            )
        }
        case "input" : {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        "px-4 border-b border-secondary-300 text-sm text-secondary-50 bg-white text-right " +
                  (isStickyColumns === true
                      ? index === 0
                          ? " left-0 sticky bg-white"
                          : row.cells.length - 1 === index
                              ? " right-0 sticky w-101 bg-white "
                              : ""
                      : "") +
                  (isStickyColumnslast2 &&
                    ((row.cells.length - 1 === index ||
                      row.cells.length - 2 === index) &&
                      " right-0 sticky w-101 bg-lightSkyblue ") +
                      (row.cells.length - 2 === index &&
                        " border-l border-gray  " (lastColumnWidth ? `  ${lastColumnWidth} ` : " right-[81px] "))) +
                  (isStickyColumnslast3 &&
                    ((row.cells.length - 1 === index ||
                      row.cells.length - 2 === index ||
                      row.cells.length - 3 === index) &&
                      " right-0 sticky w-101 bg-white ") +
                      (row.cells.length - 3 === index &&
                        " border-l border-gray right-[183px] ")) +
                  (isStickyColumnlast &&
                    (row.cells.length - 1 === index &&
                      " right-0 sticky border-l px-4 border-gray bg-white ") +
                      (row.cells.length - 1 === index && " ")) +
                  (editableRowId ? "w-3.5" : "")
                    }
                >
                    <div className={ ` justify-start  ${isEditable? globalSelectedLanguage 
                        !== defaultLangaugeId ?  "min-w-[180px]" :"min-w-[120px]" : ""} 
                        ${cellColumn?.errors?.[cellColumn?.id]? "block" : "flex"}` }>
                        { isEditable ? (
                            <>
                                <div>
                                    <InputBox
                                        label={ t(cellColumn?.Header) }
                                        id={ cellColumn.id }
                                        type={ cellColumn?.inputType? cellColumn?.inputType:"text" }
                                        name={ cellColumn?.id }
                                        value={ isFullTableEdit ? cell?.value :  cellColumn?.value ? 
                                            cellColumn?.value : "" }
                                        errors={ cellColumn?.errors }
                                        defaultValue={ "" }
                                        isRequired={ cellColumn?.isRequired ? cellColumn?.isRequired : false }
                                        maxLength={ cellColumn?.maxValue }
                                        disabled={ false }
                                        isComponentLabelValidation={ false }
                                        onChangeHandler={ (e) => cellColumn?.onChange(e,row) }
                                        labelIsRequired={ cellColumn?.labelIsRequired }
                                        className={ cellColumn?.className || "" }
                                    />
                                </div>
                                {
                                    cellColumn?.errors && cellColumn?.id  && cellColumn?.errors[cellColumn?.id ] &&<div>
                                        <ErrorField name={ cellColumn?.errors?  
                                            `${t(cellColumn?.Header) } ${cellColumn?.errors[cellColumn?.id]}`  
                                            : "" } />
                                    </div>
                                }
                            </>
                        ) : (
                            <>
                                { cell.render("Cell") }
                                <div
                                    className={
                                        "border-[#CED0D6] absolute top-0 h-fill-available" +
                          (isStickyColumns === true
                              ? index === 0
                                  ? " border-r right-0 "
                                  : row.cells.length - 1 === index
                                      ? " border-l left-0 "
                                      : ""
                              : "")
                                    }
                                ></div>
                            </>
                        ) }
                    </div>
                </td>
            )
        }
        case "datepicker" : {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        "px-4 border-b border-secondary-300 text-sm text-secondary-50 bg-white text-right " +
                  (isStickyColumns === true
                      ? index === 0
                          ? " left-0 sticky bg-white"
                          : row.cells.length - 1 === index
                              ? " right-0 sticky w-101 bg-white "
                              : ""
                      : "") +
                  (isStickyColumnslast2 &&
                    ((row.cells.length - 1 === index ||
                      row.cells.length - 2 === index) &&
                      " right-0 sticky w-101 bg-lightSkyblue ") +
                      (row.cells.length - 2 === index &&
                        " border-l border-gray " (lastColumnWidth ? `  ${lastColumnWidth} ` : " right-[81px] "))) +
                  (isStickyColumnslast3 &&
                    ((row.cells.length - 1 === index ||
                      row.cells.length - 2 === index ||
                      row.cells.length - 3 === index) &&
                      " right-0 sticky w-101 bg-white ") +
                      (row.cells.length - 3 === index &&
                        " border-l border-gray right-[183px] ")) +
                  (isStickyColumnlast &&
                    (row.cells.length - 1 === index &&
                      " right-0 sticky border-l px-4 border-gray bg-white ") +
                      (row.cells.length - 1 === index && " ")) +
                  (editableRowId ? "w-3.5" : "")
                    }
                >
                    <div className={ `flex justify-start  ${isEditable? 
                        globalSelectedLanguage !== defaultLangaugeId ? 
                            "min-w-[180px]" :"min-w-[150px]" : ""}` }>
                        { isEditable ? (
                            <CustomDatePicker
                                className=""
                                selected={ cell?.column?.value }
                                placeHolder={  t(cell?.column?.Header) }
                                value={ cell?.column?.value }
                                id={ cell?.column?.id }
                                name={ cell?.column?.id }
                                errorData={ false }
                                onChangehandler={ cell?.column?.onChange }
                                isFutureDateDisabled={ false }
                                isPastDateDisabled={ true }
                                isRequired={ false }
                                disabled={ false }
                                isselectsEnd={ true }
                                labelIsRequired={ cellColumn?.labelIsRequired }
                            />
                        ) : (
                            <>
                                { cell.render("Cell") }
                                <div
                                    className={
                                        "border-[#CED0D6] absolute top-0 h-fill-available" +
                          (isStickyColumns === true
                              ? index === 0
                                  ? " border-r right-0 "
                                  : row.cells.length - 1 === index
                                      ? " border-l left-0 "
                                      : ""
                              : "")
                                    }
                                ></div>
                            </>
                        ) }
                    </div>
                </td>
            )
        }
        case "dataWithLink" : {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        "px-4 border-b border-secondary-300 text-sm text-secondary-50 bg-white text-left " +
                  (isStickyColumns === true
                      ? index === 0
                          ? " left-0 sticky bg-white"
                          : row.cells.length - 1 === index
                              ? " right-0 sticky w-101 bg-white "
                              : ""
                      : "") +
                  (isStickyColumnslast2 &&
                    ((row.cells.length - 1 === index ||
                      row.cells.length - 2 === index) &&
                      " right-0 sticky w-101 bg-lightSkyblue ") +
                      (row.cells.length - 2 === index &&
                        " border-l border-gray  " (lastColumnWidth ? `  ${lastColumnWidth} ` : " right-[81px] "))) +
                  (isStickyColumnslast3 &&
                    ((row.cells.length - 1 === index ||
                      row.cells.length - 2 === index ||
                      row.cells.length - 3 === index) &&
                      " right-0 sticky w-101 bg-white ") +
                      (row.cells.length - 3 === index &&
                        " border-l border-gray right-[183px] ")) +
                  (isStickyColumnlast &&
                    (row.cells.length - 1 === index &&
                      " right-0 sticky border-l px-4 border-gray bg-white ") +
                      (row.cells.length - 1 === index && " ")) +
                  (editableRowId ? "w-3.5" : "")
                    }
                >
                    <div className="flex justify-start min-w-[100px]">
                        { isEditable && action?.edit ? (
                            <>
                                { cell.render("Cell") } 
                                <NavLink
                                    onClick={ () => cell.column.onActionClick(row.original) }
                                    className="nav-link text-sm text-primary-100 pl-1 
                                    underline underline-offset-4 min-w-[80px]"
                                >
                                    { t(cell?.column?.linkTitle) }
                                </NavLink>
                            </>
                        ) : 
                            
                            isEditable && action?.create ?
                                <>
                                    <InputBox
                                        label={ t(cell?.column?.Header) }
                                        id={ cell?.column.id }
                                        type={ cell?.column?.inputType? cell?.column?.inputType:"text" }
                                        name={ cell?.column.id }
                                        value={ cell?.column?.value }
                                        errors={ {} }
                                        defaultValue={ "" }
                                        isRequired={ false }
                                        maxLength={ cell?.column?.maxValue }
                                        disabled={ false }
                                        isComponentLabelValidation={ false }
                                        onChangeHandler={ (e) => cell?.column?.onChange(e) }
                                        labelIsRequired={ cellColumn?.labelIsRequired }
                                    />

                                </>
                                :
                                <>
                                    { cell.render("Cell") }
                                    <div
                                        className={
                                            "border-[#CED0D6] absolute top-0 h-fill-available" +
                          (isStickyColumns === true
                              ? index === 0
                                  ? " border-r right-0 "
                                  : row.cells.length - 1 === index
                                      ? " border-l left-0 "
                                      : ""
                              : "")
                                        }
                                    ></div> 
                                </>
                        }
                         
                    </div>
                </td>
            )
        }
        case "custom": {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        cell?.column?.styles + " px-4 border-b border-secondary-300 text-sm text-secondary-50 pt-1 " +
              (isStickyColumns === true
                  ? index === 0
                      ? ticketDetailsFilter.includes(row?.original?.repair_ticket_no) 
                          ? " bg-lightred left-0 sticky " : " left-0 sticky bg-white "
                      : row.cells.length - 1 === index
                          ? ticketDetailsFilter.includes(row?.original?.repair_ticket_no) 
                              ? " bg-lightred right-0 sticky w-101 " :  " right-0 sticky w-101 bg-white "
                          : ""
                  : "") + (isStickyColumnslast2 && ((row?.cells?.length - 2 === index  
                    && " border-l border-gray  " + `${ rightPosition133 
                        ? " right-[133px] " : right73 ? " right-[73px] " : " right-[112px] "}` ) 
                        + ((row?.cells?.length - 1 === index || row?.cells?.length - 2 === index) 
                        && " right-0 sticky min-w-101 px-4 bg-white ")))
                  + (isStickyColumnslast3 && (((row?.cells?.length - 1 === index 
                    || row?.cells?.length - 2 === index || row?.cells?.length - 3 === index)  
                    && " right-0 sticky min-w-[105px] px-4  bg-white   ") + (row?.cells?.length - 3 === index 
                        && `"  border-l  border-gray " ${right186 ? " right-[186px] " : " right-[183px] "}`) + (row?.cells?.length - 2 === index 
                            &&  " right-[81px] " ) ))
                  + (isStickyColumnlast && (((row.cells.length - 1 === index)  
                  && " right-0 sticky border-l px-4 border-gray bg-white ") 
                  + (row.cells.length - 1 === index && " ") ))
                    }
                >
                    { cell.render("Cell") }
                    <div
                        className={
                            "border-[#CED0D6] absolute top-0 h-fill-available" +
                (isStickyColumns === true
                    ? index === 0
                        ? " border-r right-0 "
                        : row.cells.length - 1 === index
                            ? " border-l left-0 "
                            : ""
                    : "")
                        }
                    ></div>
                </td>
            )
        }
        case "updatedBy": {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        "px-4 border-b border-secondary-300 text-sm text-secondary-50 py-[2.5px] bg-white " +
              (isStickyColumns === true
                  ? index === 0
                      ? " left-0 sticky bg-white"
                      : row.cells.length - 1 === index
                          ? " right-0 sticky w-101 bg-white "
                          : ""
                  : "")  + (isStickyColumnslast2 && (((row.cells.length - 1 === index 
                    || row.cells.length - 2 === index)  && " right-0 sticky w-101 bg-lightSkyblue ") 
                    + (row.cells.length - 2 === index && " border-l border-gray  " (lastColumnWidth 
                        ? `  ${lastColumnWidth} ` : " right-[81px] ")) ))
                  + (isStickyColumnslast3 && (((row.cells.length - 1 === index 
                    || row.cells.length - 2 === index || row.cells.length - 3 === index) 
                     && " right-0 sticky w-101 bg-white ") + (row.cells.length - 3 === index 
                        && " border-l border-gray right-[183px] ") ))
                  + (isStickyColumnlast && (((row.cells.length - 1 === index)  
                  && " right-0 sticky border-l px-4 border-gray bg-white ") 
                  + (row.cells.length - 1 === index && " ") ))
                    }
                >
                    <div className="flex flex-col">
                        <span>{ textLineClamp(cell.value, "min-w-[120px]") }</span>{ " " }
                        <span className="text-secondary-200 text-xs">{ row?.original?.updated_at 
                        && convertDateTimeByFormat(row?.original?.updated_at) }</span>
                    </div>
                    <div
                        className={
                            "border-[#CED0D6] absolute top-0 h-fill-available" +
                (isStickyColumns === true
                    ? index === 0
                        ? " border-r right-0 "
                        : row.cells.length - 1 === index
                            ? " border-l left-0 "
                            : ""
                    : "")
                        }
                    ></div>
                </td>
            )
        }
        default: {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        cell?.column?.styles + " px-4 border-b border-secondary-300 text-sm text-secondary-50 pt-1 " +
              (isStickyColumns === true
                  ? index === 0
                      ? " left-0 sticky bg-white "
                      : row.cells.length - 1 === index
                          ? " right-0 sticky w-101 bg-white "
                          : ""
                  : "") + (isStickyColumnslast2 && (((row?.cells?.length - 1 === index 
                    || row?.cells?.length - 2 === index) 
                   && " right-0 sticky min-w-101 px-4 border-gray bg-white ") 
                   + (row?.cells?.length - 2 === index && (lastColumnWidth 
                       ? ` border-l ${lastColumnWidth} ` : ((module === "finishedGoods" 
                        || module === "allowedMaterials")
                           ? " border-l right-[73px] ": " border-l right-[81px] "))) ))
                  + (isStickyColumnslast3 && (((row?.cells?.length - 1 === index 
                    || row?.cells?.length - 2 === index || row?.cells?.length - 3 === index)  
                    && " right-0 sticky min-w-101 px-4  bg-white   ") + (row?.cells?.length - 3 === index 
                        && ` " border-l  border-gray " ${right162 ? " right-[162px] " : right186 ? " right-[186px] " : " right-[178px] "}`) 
                        + (row?.cells?.length - 2 === index && " right-[81px] ") ))
                  + (isStickyColumnlast && (((row.cells.length - 1 === index)  
                  &&  ` right-0 sticky border-l px-4 border-gray   ${(viewPosition?.position_number !==undefined 
                    && row?.original?.position_number === viewPosition?.position_number) 
                      ? "bg-lighterBlue " : "bg-white "}  ` ) 
                    + (row.cells.length - 1 === index && " ") ))

                  + (isStickyColumnsFirst2 && (((index === 0 || index === 1) 
                  && " sticky bg-white left-0 ") 
                  + (index === 1 && " left-[74.58px] border-r border-gray ")  ))   
                    }
                >
                    { cell.render("Cell") }
                    <div
                        className={
                            "border-[#CED0D6] absolute top-0 h-fill-available " +
                (isStickyColumns === true
                    ? index === 0
                        ? " border-r right-0 "
                        : row.cells.length - 1 === index
                            ? " border-l left-0 "
                            : ""
                    : "")
                        }
                    ></div>
                </td>
            )
        }
        }
    }

    const exportJSONToExcel = async () => {
        let result = await getDownloadData()
    
        const worksheet = XLSX?.utils?.json_to_sheet(
            isCountryHubAssociation ? result?.data : result
        )
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, downloadData.sheet)
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        })
        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
        })
        saveAs(blob, downloadData.fileName)
    }

    const handleDownloadExcel = () => {
        if (isJsondownload) {
            exportJSONToExcel()
        } else {
            downloadExcel({
                fileName: downloadData.fileName,
                sheet: downloadData.sheet,
                tablePayload: {
                    header: downloadData.header,
                    body: downloadData.body
                }
            })
        }
    }

    const getExportDownloadAsExcel = ()=> {
        getExportDownload()
    }

    useEffect(() => {
        if (props.setShowPagination) {
            if (
                state.globalFilter !== "" &&
        state.globalFilter !== undefined &&
        rows.length < 10
            ) {
                props.setShowPagination(false)
            } else {
                props.setShowPagination(true)
            }
        }
    }, [rows])

    useImperativeHandle(
        props?.selectedRows,
        () => ({
            getSelectedRows: () => selectedFlatRows
        }),
        [selectedFlatRows]
    )
    const tableRowClick =(e, row)=>{
        if(!e.target.hasAttribute("src") && !e.target.hasAttribute("type")) {
            setReversePositionNumber(row?.original?.position_number)
        }
        
    }
    return (
        <>  
            {
                warrantyTableTopSelect &&  warrantyTableTopSelect 
            }
          
            {
                
                !disableHeader && customFilters && <>
                    { uploadBtnRender }
                    <div className="flex justify-between gap-4 items-center px-4 self-stretch">
                        { customDropdownsRender }
                        <div className="flex gap-4 items-center">
                            { !disableSearch && (
                                <GlobalFilter
                                    globalFilter={ state.globalFilter }                               
                                    setGlobalFilter={ setGlobalFilter }
                                    isCustomSearch={ isCustomSearch }
                                    onCustomSearch={ onCustomSearch }
                                    customsearchtext={ customsearchtext }
                                    searchWrapperClass={ props?.searchWrapperClass }
                                    placeHolder = { props?.searchPlaceHolder }
                                />
                            ) }
                            
                            { (data?.length > 0 && downloadFeature) && (
                                <div className="flex-auto">
                                    <button onClick={ handleDownloadExcel } type="button"
                                        className="flex w-[36px] h-[36px] justify-center items-center gap-[10px]
                                        rounded-full border border-primary-100 hover:border-0 hover:bg-primary-150">
                                        <img
                                            alt="Download"
                                            src={ downloadIcon }
                                            height={ "16px" }
                                            width={ "16px" }
                                            title="Download"
                                        />
                                    </button>
                                </div>
                            ) }

                            { checkBoxFilter && assignedPartCheckboxRender }
                        </div>
                    </div>
                </>
            } 

            { !disableHeader && !customFilters && <>
                <div className={ `flex justify-between gap-4 items-center px-4 self-stretch 
                    ${!isEnabledHotSpotEdit ? "hidden" : ""}` }>
                    { advanceSearchTopSearch && advanceSearchTopSearch } 
                    { isCustomHeading && customHeader }
                    { !advanceSearchTopSearch &&  <div>
                        <div className="flex flex-col gap-1">
                            <h3 className={ "text-md font-black text-primary-50  flex-[1_0_0] mb-2" }>
                                { `${t(title)}` }{ titleDetails }</h3>
                            { subDetails && (<p>{ `${t(subDetails)}` }</p> ) }
                            <p className="text-sm font-normal text-secondary-200">{ subTitle }</p>
                        </div>
                        
                        <div className="relative w-40 add-lang-slect">
                            { filterDropdown && <CustomDropdown
                                placeholder={ t(filterDropdownProps?.title) }
                                defaultValue={ filterDropdownProps?.value }
                                options={ filterDropdownProps?.options || [] }
                                name={ filterDropdownProps?.name }
                                changeHandler={ filterDropdownProps?.onChange }
                                errorData={ [] }
                                isRequired={ false }
                                isMulti={ false }
                                disabled={ false }
                                isValueSelect={ true }
                                dataTestId={ filterDropdownProps?.name }
                            /> 
                            }
                        </div>
                    </div> }
                    { !searchFilterSectionBottom && <div className={ `flex gap-4 items-center 
                        ${filterDropdown ? "self-end": ""}` }>
                        { !disableSearch && (
                            <GlobalFilter
                                globalFilter={ state.globalFilter }
                                setGlobalFilter={ setGlobalFilter } 
                                clearcustomsearchtext={ clearcustomsearchtext } 
                                setclearCustomsearchtext={ setclearCustomsearchtext }                             
                                isCustomSearch={ isCustomSearch }
                                onCustomSearch={ onCustomSearch }
                                customsearchtext={ customsearchtext }
                                searchWrapperClass={ props?.searchWrapperClass }
                                placeHolder= { props?.searchPlaceHolder  }
                            />
                        ) }
                        { warrantyTableTicketFilterButton && warrantyTableTicketFilterButton }
                        { ispartsTopDropdown && partsTopDropDownPrice }
                        { translateFeature && (
                            <div className="flex w-[152px]">
                                { !isCustomLanguageSelector && <><label 
                                    className="text-xs text-secondary-200 absolute bg-white 
                                z-[1] top-[-8px] left-[10px]">
                                    { t("common.selectLanguage") }
                                </label><LanguageSelector setCurrentLanguages={ setCurrentLanguages } 
                                    currentVal={ 12 }/> 
                                </> }
                                { isCustomLanguageSelector && <Language  changeHandler ={ languageChangeHandler } 
                                    globalLanguageChange={ globalLanguageChange } renderKey={ renderKey }/> }
                            </div>
                        ) }
                         
                        { (data?.length > 0 && downloadFeature) && (
                            <div className="flex-auto">
                                <button onClick={ handleDownloadExcel } type="button"
                                    className="flex w-[36px] h-[36px] justify-center items-center gap-[10px]
                        rounded-full border border-primary-100 hover:border-0 hover:bg-primary-150">
                                    <img
                                        alt="Download"
                                        src={ downloadIcon }
                                        height={ "16px" }
                                        width={ "16px" }
                                        title="Download"
                                    />
                                </button>
                            </div>
                        ) }
                        { isExport && (
                            <div className="flex-auto">
                                <button onClick={ getExportDownloadAsExcel } type="button"
                                    className="flex w-[36px] h-[36px] justify-center items-center gap-[10px]
                                    rounded-full border border-primary-100 hover:border-0 hover:bg-primary-150">
                                    <img
                                        alt="Download"
                                        src={ downloadIcon }
                                        height={ "16px" }
                                        width={ "16px" }
                                        title="Download"
                                    />
                                </button>
                            </div>
                        ) }
                        { filterFeature && (
                            <div className="flex-auto relative">
                                <button type="button" onClick={ handleFilterClick }
                                    className="flex w-[36px] h-[36px] justify-center items-center gap-[10px]
                        rounded-full border border-primary-100 hover:border-0 hover:bg-primary-150">
                                    <img
                                        alt={ t("common.filter") }
                                        src={ filterIcon }
                                        height={ "16px" }
                                        width={ "16px" }
                                        title="Filter"
                                    />
                                </button>
                                { isFilteredValue &&<span className="absolute w-[14px] h-[14px] 
                                shrink-0 border rounded-full background bg-tertiary-500 right-[0px]
                                 top-[4px] solid border-white -mt-2"></span> }
                            </div>
                        ) }
                        { uploadFeature && permissionDetails?._write && (
                            <div className="flex-auto">
                                <button
                                    type="button"
                                    onClick={ () => props.onUpload() }
                                    disabled={ isUploadFeatureDisabled }
                                    className="text-blue bg-white border border-solid hover:border-0
                                     hover:bg-primary-150 border-primary-50 font-bold text-primary-50 
                                     text-sm h-9 px-4 outline-none focus:outline-1 focus:outline-black 
                                     rounded-full disabled:text-secondary-50 disabled:border-0"
                                >
                                    { `+ ${t(`${uploadButtonTitle}`)}` }
                                </button>
                            </div>
                        ) }
                        { salesOrgFilter && (
                            <div className="flex w-[152px]">
                                <CustomDropdown
                                    placeholder={ t("autoApprovalRules.salesOrg") }
                                    defaultValue={ selectedSalesOrg || [] }
                                    options={ salesOrgOptions }
                                    name="sales_org_id"
                                    changeHandler={ salesOrgFilterHandler }
                                    errorData={ {} }
                                    isRequired={ false }
                                    disabled={ false }
                                    isMulti={ true }
                                    isMultiWithCheckbox={ true }
                                    isMultiValueSelect={ true }
                                    selectedItemLength={ 1 }
                                    className={ "w-full" }
                                    renderKey={ renderKey }
                                    AllSelectLabel = { "ALL" }
                                    isAllOption = { true }
                                />
                            </div>
                        ) }
                        { rejectFeature && permissionDetails?._write && (
                            <div className="flex-auto">
                                <button
                                    type="button"
                                    onClick={ () => props.onReject() }
                                    disabled={ addNewFeatureDisabled }
                                    className={ `rounded-full w-full font-bold text-sm 
                                        hover:bg-primary-150 hover:text-primary-50 h-9
                                         px-4 ${props.customButtonClass 
                                ? props.customButtonClass : "bg-primary-100 text-white" }` }
                                >
                                    { t("common.reject") }
                                </button>
                            </div>
                        ) }
                        { addNewFeature && permissionDetails?._write && (
                            <div className="flex-auto">
                                <button
                                    type="button"
                                    onClick={ () => props.onAddNew() }
                                    disabled={ addNewFeatureDisabled }
                                    className={ `rounded-full w-full font-bold text-sm 
                                        hover:bg-primary-150 hover:text-primary-50 h-9 px-4 
                                        ${props.customButtonClass 
                                ? props.customButtonClass : "bg-primary-100 text-white" }` }
                                >
                                    { isDeleteRow
                                        ? `+ ${t(`${props.buttonTitle}`)}`
                                        : isButonURL ? props.buttonTitle :  
                                            props?.addNewButtonTitle ? 
                                                `+ ${t("common.add")} ${t(props?.addNewButtonTitle)}`:
                                                props?.customButtonTitle ? `${props?.customButtonTitle}`
                                                    : `+ ${t("common.add")} ${t(title)}`  
                                    }
                                </button>
                            </div>
                        ) }
                        { addNewButton && (
                            <div className="flex-auto">
                                <button
                                    type="button"
                                    onClick={ () => addNewButtonhandler() }
                                    className={ `rounded-full w-full font-bold text-sm hover:bg-primary-150 hover:text-primary-50 h-9 px-4 ${props.customButtonClass ? props.customButtonClass : "bg-primary-100 text-white" }` }
                                >{ addNewButtonText }
                                </button>
                            </div>
                        ) }
                        { isDropdownButton && dropdownMenus && permissionDetails?._write && (
                            <div className="flex-auto">
                                <DropDownButton
                                    label={ props?.buttonTitle }
                                    buttonWrapperClass={ props?.buttonliWrapper }
                                    subMenus={ dropdownMenus }
                                    disbaled={ addNewFeatureDisabled }
                                />
                            </div>
                        )
                        }
                        { sortFeature && (
                            <div className="flex w-full gap-4 min-w-40">
                                <CustomDropdown
                                    options={ props.sortOptions }
                                    placeholder={ t("common.sortBy") }
                                    defaultValue={ sortValue }
                                    className="w-full h-9 px-4 outline-0 placeholder-secondary-50 fontSize-sm"
                                    changeHandler={ (e) => {
                                        setSortValue(e.value)
                                        props.onSelectSort(e.value)
                                    } }
                                    value={ sortValue }
                                    isRequired={ false }
                                />
                            </div>
                        ) }
                        { customButtonFeature && (
                            <div className="flex w-[240px]">
                                { customButton?.type == "Dropdown" && (
                                    <Dropdown
                                        className={ "h-[35px] w-[98%] mt-0 mr-0" }
                                        value=""
                                        placeholder={ t("lms.trainingCompletionStatus") }
                                        options={ customButton.options }
                                        name="status"
                                        id="status"
                                        changeHandler={ (e) => customButton?.onChange(e.value) }
                                        isMulti={ false }
                                        isNotRequired={ true }
                                    />
                                ) }
                                { customButton?.type != "Dropdown" && (
                                    <button
                                        type="button"
                                        onClick={ () => customButton?.onClick() }
                                        className="flex items-center gap-[4px] rounded-full w-full 
                                        bg-primary-100 text-white font-bold text-sm 
                                         hover:bg-primary-150 hover:text-primary-50 h-9 px-4"
                                    >
                                        { `${customButton?.title}` }
                                        { customButton?.icon && (
                                            <img
                                                src={ customButton?.icon }
                                                className="w-[12px] h-[12px] flex-shrink-0"
                                                alt="calendarIcon"
                                            />
                                        ) }
                                    </button>
                                ) }

                            </div>
                        ) }
                        { addNewLinkFeature && permissionDetails?._write && (<div className="flex-auto">
                            <button
                                type="button"
                                onClick={ () => addNewLinkFeatureProps?.onActionClick() }
                                disabled={ addNewLinkFeatureProps?.isDisabled }
                                className={ `rounded-full w-full font-bold text-sm 
                                    hover:bg-primary-150 hover:text-primary-50 h-9 
                                    px-4 ${props.customButtonClass ? props.customButtonClass : "bg-primary-100 text-white" }` }
                            >
                                { t(addNewLinkFeatureProps?.linkLabel) }
                            </button> </div>) }
                        { props.isPrintScreen && <div className="flex-auto">
                            <button
                                type="button"
                                onClick={ () => props?.onPrintHandler() }
                                className="flex gap-2 mr-[10px] text-xs font-light text-primary-100 underline"
                            ><img className="w-[12px] h-[12px] flex-shrink-0" src={ print } alt="Print"/>{ t("common.print") }</button>
                        </div> }
                    </div> }                 
                </div>
                
                {
                    warrantyTableDetailTopTab && warrantyTableDetailTopTab
                }
                
                { searchFilterSectionBottom && 
                    <div className="flex justify-end px-4">
                        <div></div>
                        <div className={ `flex gap-4 items-center flex-end  ${filterDropdown ? "self-end": ""}` }>
                            { !disableSearch && (
                                <GlobalFilter
                                    globalFilter={ state.globalFilter }
                                    setGlobalFilter={ setGlobalFilter }
                                    isCustomSearch={ isCustomSearch }
                                    onCustomSearch={ onCustomSearch }
                                    customsearchtext={ customsearchtext }
                                    searchWrapperClass={ props?.searchWrapperClass }
                                    placeHolder = { props?.searchPlaceHolder }
                                />
                            ) }
                            { translateFeature && (
                                <div className="flex w-[152px]">
                                    { !isCustomLanguageSelector && <><label className="text-xs text-secondary-200 
                                    absolute bg-white z-[1] top-[-8px] left-[10px]">
                                        { t("common.selectLanguage") }
                                    </label><LanguageSelector setCurrentLanguages={ setCurrentLanguages } 
                                        currentVal={ 12 }/> 
                                    </> }
                                    { isCustomLanguageSelector && <Language  changeHandler ={ languageChangeHandler } 
                                        globalLanguageChange={ globalLanguageChange } renderKey={ renderKey }/> }
                                </div>
                            ) }
                            
                            { (data?.length > 0 && downloadFeature) && (
                                <div className="flex-auto">
                                    <button onClick={ handleDownloadExcel } type="button"
                                        className="flex w-[36px] h-[36px] justify-center items-center gap-[10px]
                    rounded-full border border-primary-100 hover:border-0 hover:bg-primary-150">
                                        <img
                                            alt="Download"
                                            src={ downloadIcon }
                                            height={ "16px" }
                                            width={ "16px" }
                                            title="Download"
                                        />
                                    </button>
                                </div>
                            ) }
                            { filterFeature && (
                                <div className="flex-auto relative">
                                    <button type="button" onClick={ handleFilterClick }
                                        className="flex w-[36px] h-[36px] justify-center items-center gap-[10px]
                    rounded-full border border-primary-100 hover:border-0 hover:bg-primary-150">
                                        <img
                                            alt={ t("common.filter") }
                                            src={ filterIcon }
                                            height={ "16px" }
                                            width={ "16px" }
                                            title="Filter"
                                        />
                                    </button>
                                    { isFilteredValue &&<span className="absolute w-[14px] h-[14px] 
                                    shrink-0 border rounded-full background bg-tertiary-500 right-[0px] 
                                    top-[4px] solid border-white -mt-2"></span> }
                                </div>
                            ) }
                            { uploadFeature && permissionDetails?._write && (
                                <div className="flex-auto">
                                    <button
                                        type="button"
                                        onClick={ () => props.onUpload() }
                                        className="text-blue bg-white border border-solid 
                                        hover:border-0 hover:bg-primary-150 border-primary-50 
                                        font-bold text-primary-50 text-sm h-9 px-4 outline-none 
                                        focus:outline-1 focus:outline-black rounded-full 
                                        disabled:bg-primary-150 disabled:text-secondary-50 disabled:border-0"
                                    >
                                        { `+ ${t(`${uploadButtonTitle}`)}` }
                                    </button>
                                </div>
                            ) }
                            {
                                ( csvDownloadFeature && <div className="flex-auto">
                                    <button onClick={ handleDownloadPerformCSVExcel } disabled={ addNewFeatureDisabled } type="button"
                                        className="flex w-[36px] h-[36px] justify-center items-center gap-[10px]
                rounded-full border border-primary-100 hover:border-0 hover:bg-primary-150">
                                        <img
                                            alt="Download"
                                            src={ downloadIcon }
                                            height={ "16px" }
                                            width={ "16px" }
                                            title="Download"
                                        />
                                    </button>
                                </div>)
                            }
                            { rejectFeature && permissionDetails?._write && (
                                <div className="flex-auto">
                                    <button
                                        type="button"
                                        onClick={ () => props.onReject() }
                                        disabled={ addNewFeatureDisabled }
                                        className={ `rounded-full w-full font-bold text-sm 
                                            hover:bg-primary-150 hover:text-primary-50 h-9 
                                            px-4 ${props.customButtonClass 
                                    ? props.customButtonClass : "bg-primary-100 text-white" }` }
                                    >
                                        { t("common.reject") }
                                    </button>
                                </div>
                            ) }
                            { addNewFeature && permissionDetails?._write && (
                                
                                <div className="flex-auto">
                                    <button
                                        type="button"
                                        onClick={ () => props.onAddNew() }
                                        disabled={ addNewFeatureDisabled }
                                        className={ `rounded-full w-full font-bold text-sm 
                                            hover:bg-primary-150 hover:text-primary-50 h-9 
                                            px-4 ${props.customButtonClass 
                                    ? props.customButtonClass : "bg-primary-100 text-white" }` }
                                    >
                                        { isDeleteRow
                                            ? `+ ${t(`${props.buttonTitle}`)}`
                                            : isButonURL ? props.buttonTitle :  
                                                props?.addNewButtonTitle ? 
                                                    `+ ${t("common.add")} ${t(props?.addNewButtonTitle)}`:
                                                    props?.customButtonTitle ? `${props?.customButtonTitle}`
                                                        : `+ ${t("common.add")} ${t(title)}`  
                                        }
                                    </button>
                                </div>
                            ) }
                            { isDropdownButton && dropdownMenus && permissionDetails?._write && (
                                <div className="flex-auto">
                                    <DropDownButton
                                        label={ props?.buttonTitle }
                                        buttonWrapperClass={ props?.buttonliWrapper }
                                        subMenus={ dropdownMenus }
                                        disbaled={ addNewFeatureDisabled }
                                    />
                                </div>
                            )
                            }
                            { sortFeature && (
                                <div className="flex w-full gap-4 min-w-40">
                                    <CustomDropdown
                                        options={ props.sortOptions }
                                        placeholder={ t("common.sortBy") }
                                        className="w-full h-9 px-4 outline-0 placeholder-secondary-50 fontSize-sm"
                                        changeHandler={ (e) => {
                                            setSortValue(e.value)
                                            props.onSelectSort(e.value)
                                        } }
                                        value={ sortValue }
                                        isRequired={ false }
                                    />
                                </div>
                            ) }
                            { customButtonFeature && (
                                <div className="flex w-[240px]">
                                    { customButton?.type == "Dropdown" && (
                                        <Dropdown
                                            className={ "h-[35px] w-[98%] mt-0 mr-0" }
                                            value=""
                                            placeholder={ t("lms.trainingCompletionStatus") }
                                            options={ customButton.options }
                                            name="status"
                                            id="status"
                                            changeHandler={ (e) => customButton?.onChange(e.value) }
                                            isMulti={ false }
                                            isNotRequired={ true }
                                        />
                                    ) }
                                    { customButton?.type != "Dropdown" && (
                                        <button
                                            type="button"
                                            onClick={ () => customButton?.onClick() }
                                            className="flex items-center gap-[4px] rounded-full w-full 
                                            bg-primary-100 text-white font-bold text-sm  
                                            hover:bg-primary-150 hover:text-primary-50 h-9 px-4"
                                        >
                                            { `${customButton?.title}` }
                                            { customButton?.icon && (
                                                <img
                                                    src={ customButton?.icon }
                                                    className="w-[12px] h-[12px] flex-shrink-0"
                                                    alt="calendarIcon"
                                                />
                                            ) }
                                        </button>
                                    ) }

                                </div>
                            ) }
                            { addNewLinkFeature && permissionDetails?._write && (<NavLink
                                onClick={ () => addNewLinkFeatureProps?.onActionClick() }
                                className={ `nav-link text-sm text-primary-100 underline 
                                    underline-offset-4 ${addNewLinkFeatureProps?.isDisabled 
                                        && "pointer-events-none"}` }
                            >
                                { t(addNewLinkFeatureProps?.linkLabel) }
                            </NavLink>) }
                        </div>
                    </div>
                }
                {
                    warrantyTableDetailTopButton && warrantyTableDetailTopButton
                }
                
                { allSecondaryCheckCompnent && allSecondaryCheckCompnent }
                { tbaleWithTopImageData && <div className="w-full flex gap-6 pl-6 pr-6 ">
                    <div className="w-1/4 h-[328px] p-2 flex items-center 
                    justify-center border border-secondary-300">
                        <img
                            src={ bigImageUrls[imageData?.id]  }
                            className={ `${
                                bigImageUrls[imageData?.id] === "/assets/images/image-not-available.png"
                                    ? "w-[32px] ml-4"
                                    : "max-w-[350px] max-h-[325px]"
                            } ` }
                            alt="product_image"
                        />
                    </div>
                    <div className="w-3/4 flex flex-col justify-center">
                        <p className="text-sm font-normal">{ imageData?.marketing_name }</p>
                        <h4 className="text-xl mt-3 font-bold text-primary-50 mb-1 text-justify">{
                            imageData?.model_description? extractPlainText(imageData?.model_description) : "" }</h4>
                        { imageData?.feature_text!=="\"undefined\"" ? 
                            imageData?.feature_text && !isValidRichText(imageData?.feature_text) && (
                                <p 
                                    className="mt-3 text-sm font-normal">{ extractPlainText(imageData?.feature_text) }
                                </p>) :"" }
                        { imageData?.feature_text!=="\"undefined\"" ?  imageData?.feature_text && isValidRichText(imageData?.feature_text) && (
                            <RichTextEditor 
                                richTextData={ imageData?.feature_text }
                                onChangeRichTextData={ () => {} }
                                readOnly={ true }
                            />):"" }
                    </div>
                </div> }
            </>
            }
            <div className={ (!props?.isEditMode && props.isHotSpot) 
                ? "flex border-y border-secondary-300 w-full": "flex  w-full" }>
                { isEditHotSpot &&  drawingImage  }
                { isEnabledHotSpotEdit && <div className={ ` ${props?.hideOverFlowAuto 
                    ? " " : "overflow-auto"} custome-scroll custome-scroll-x ${tableMinHeight} ${isEditHotSpot 
                    ? "w-1/2" : "w-full"} ${!isPaginationEnabled ? "max-h-[1000px]": ""}` } >
                    <table { ...getTableProps() } className={ `table-auto text-left w-full ${isSearchButtonClicked ? " " : "hidden "}`  
                        + ((isStickyColumnslast2 || isStickyColumns || isStickyColumnslast3 
                        || isStickyColumnlast)  
                        && " border-separate border-spacing-0" ) } data-test-id={ props?.dataTestId }>
                        <thead className="bg-lightSkyblue">
                            { headerGroups.map((headerGroup) => (
                                <tr { ...headerGroup.getHeaderGroupProps() } role="row">
                                    { headerGroup.headers.map((column, index) => (
                                        <th
                                            { ...column.getHeaderProps(column.getSortByToggleProps()) }
                                            { ...((enableCustomSort && column?.canSort) && {
                                                onClick: () => handleSortChange(column?.id)
                                            }) }
                                            className={
                                                " px-4 text-sm font-bold text-primary-50 py-2 " +
                      (isStickyColumns === true
                          ? index === 0
                              ? " left-0 sticky bg-lightSkyblue "
                              : headerGroup.headers.length - 1 === index
                                  ? " right-0 sticky w-101 bg-lightSkyblue "
                                  : ""
                          : "") + (isStickyColumnslast2 && (((headerGroup.headers.length - 1 === index || headerGroup.headers.length - 2 === index)  && " right-0 sticky w-101 bg-lightSkyblue ") 
                          + (headerGroup.headers.length - 2 === index && (lastColumnWidth ? ` border-l border-gray   ${lastColumnWidth} ` : ((module === "finishedGoods" || module === "allowedMaterials")? " right-[73px] border-l border-gray " : " right-[81px] border-l border-gray tt ") ) ) )) + 
                          (isStickyColumnslast3 && (((headerGroup.headers.length - 1 === index || headerGroup.headers.length - 2 === index || headerGroup.headers.length - 3 === index)  && " right-0 sticky w-101 bg-lightSkyblue min-w-[81px] ") 
                          + (headerGroup.headers.length - 3 === index && (module === "PFPDetailedReport"? " right-[162px] border-l border-gray  " : `"  border-l border-gray  " ${right186 ? " right-[186px] " : right183th ? " right-[183px] " : " right-[178px]  "}`)) + (headerGroup.headers.length - 2 === index && " right-[81px] ") ) ) 
                          + (isStickyColumnlast && (((headerGroup.headers.length - 1 === index)  && " right-0 sticky bg-lightSkyblue min-w-[81px] ") 
                          + (headerGroup.headers.length - 1 === index && " border-l border-gray ") )) + 
                          + ((isStickyColumns || isStickyColumnslast2 || isStickyColumnslast3 || isStickyColumnlast) && " whitespace-nowrap ") +
                        (((column.id === "action" || column.type === "edit") && column.textRight == true) ? " text-right min-w-[81px] " : "") +
                        (column.type === "custom" ? (isStickyColumnslast2 && headerGroup.headers.length - 2 === index && `${ rightPosition133 ? " !right-[133px]  " :  right73 ? " !right-[73px] " :  " !right-[112px] "}`) : " ")

                        + (isStickyColumnsFirst2 && (((index === 0 || index === 1) && " sticky bg-lightSkyblue left-0 ") + (index === 1 && " left-[74.58px] border-r border-gray ")  ))
                                            }
                                        >
                                            <div className=" inline-flex items-center gap-2 ">
                                                { column.render("Header") }
                                                {
                                                    enableCustomSort ?
                                                        column?.canSort && (                                               
                                                            <span className="shrink-0">
                                                                { sortBy?.column === column.id ? sortBy?.order === "DESC" ?
                                                                    <img
                                                                        src={ downIcon }
                                                                        className="text-gray-600 h-4 w-4 fill-current"
                                                                        height={ "16px" }
                                                                        width={ "16px" }
                                                                        alt="sort"
                                                                    /> 
                                                                    :
                                                                    <img
                                                                        src={ upIcon }
                                                                        className="text-gray-600 h-4 w-4 fill-current"
                                                                        height={ "16px" }
                                                                        width={ "16px" }
                                                                        alt="sort"
                                                                    /> 
                                                                    :
                                                                    <img
                                                                        src={ sortIcon }
                                                                        className="text-gray-600 h-4 w-4 fill-current"
                                                                        height={ "16px" }
                                                                        width={ "16px" }
                                                                        alt="sort"
                                                                    />
                                                                }
                                                            </span>
                                                        )
                                                        : 
                                                        <span className="shrink-0">
                                                            {
                                                                column.isSorted
                                                                    ? column.isSortedDesc
                                                                        ? <img
                                                                                src={ downIcon }
                                                                                className="text-gray-600 h-4 w-4 fill-current"
                                                                                height={ "16px" }
                                                                                width={ "16px" }
                                                                                alt="sort"
                                                                        />
                                                                        : <img
                                                                                src={ upIcon }
                                                                                className="text-gray-600 h-4 w-4 fill-current"
                                                                                height={ "16px" }
                                                                                width={ "16px" }
                                                                                alt="sort"
                                                                        />
                                                                    : column.Header?.name == "emptyRenderer" 
                                                        || column.disableSortBy ? <></> : <img
                                                            src={ sortIcon }
                                                            className="text-gray-600 h-4 w-4 fill-current"
                                                            height={ "16px" }
                                                            width={ "16px" }
                                                            alt="sort"
                                                                        /> }
                                                        </span>
                                                }
                                                
                                            </div>
                                            <div
                                                className={
                                                    "border-[#CED0D6] absolute top-0 h-fill-available" +
                        (isStickyColumns === true
                            ? index === 0
                                ? " border-r right-0 "
                                : headerGroup.headers.length - 1 === index
                                    ? " border-l left-0 "
                                    : ""
                            : "")
                                                }
                                            ></div>
                                        </th>
                                    )) }
                                </tr>
                            )) }
                        </thead>
                        { (loader || status === "pending") && <Loader loading={ true } /> }
                        { (status !== "pending" && data && data?.length === 0) || showNoRecords ? (
                            <tr  role="row">
                                <td
                                    colSpan={ columns.length }
                                    className="text-center	pt-5 text-#34383F text-1xl font-Avenir"
                                >
                                    { customeMessageNoRecord ? customeMessageNoRecord : t("common.noRecordsMsg") }
                                </td>
                            </tr>
                        ) : (
                            <tbody { ...getTableBodyProps() }>
                                { rows.map((row, index) => {
                                    prepareRow(row)
                                    return (
                                        <>
                                            <tr { ...row.getRowProps() }   ref={ row?.original?.position_number === viewPosition?.position_number ? scrollRef : null } onClick={ (e) => tableRowClick(e, row) }
                                                className={ `hover:bg-lighestgray 
                                                    ${(viewPosition?.position_number !==undefined 
                                                && (row?.original?.position_number === viewPosition?.position_number) || (reversePositionNumber && (reversePositionNumber === row?.original?.position_number))) ? 
                                            "bg-lighterBlue scroll-Class " : "" } 
                                                    ${ticketDetailsFilter.includes(row?.original?.repair_ticket_no) 
                                            ? "bg-lightred hover:bg-lighestgray " : ""}` } role="row">
                                                { row.cells.map((cell, index) => (
                                                    <> { renderDataTable(row, cell, index) }</>
                                                )) }
                                            </tr>
                                            { /* Expanded Nested Table without Header */ }
                                            { expandedRows && expandedRows[index] && (
                                                <>
                                                   
                                                    { /* Nested Table Content */ }
                                                     
                                                    { row?.original?.secondary_service_center?.map((nestedRow, index) => (
                                                        <tr key={ `nestedIndex_${index}` } className="bg-primary-200">
                                                            { columns?.map((col, colIndex) => (
                                                                
                                                                <td  key={ colIndex } 
                                                               
                                                                    className={
                                                                        row?.cells?.column?.styles 
                                                                        + " px-4 border-b border-secondary-300 text-sm text-secondary-50 pt-1 " +
                                                          (isStickyColumns === true
                                                              ? index === 0
                                                                  ? " left-0 sticky bg-white "
                                                                  : row.cells.length - 1 === index
                                                                      ? " right-0 sticky w-101 bg-white "
                                                                      : ""
                                                              : "") + (isStickyColumnslast2 
                                                                && (((row?.cells?.length - 1 === index 
                                                                || row?.cells?.length - 2 === index)  
                                                                && " right-0 sticky min-w-101 border-l px-4 border-gray bg-white ") 
                                                                + (row?.cells?.length - 2 === index && (lastColumnWidth 
                                                                    ? `  ${lastColumnWidth} ` : " right-[81px] ")) ))
                                                              + (isStickyColumnslast3 
                                                                && (((row?.cells?.length - 1 === index 
                                                                    || row?.cells?.length - 2 === index 
                                                                    || row?.cells?.length - 3 === index)  
                                                                && " right-0 sticky min-w-101 px-4  bg-white   ") 
                                                                + (row?.cells?.length - 3 === index 
                                                                    && " right-[183px] border-l  border-gray ")
                                                                 + (row?.cells?.length - 2 === index 
                                                                    && " right-[81px] ") ))+ (isStickyColumnlast 
                                                                        && (((row.cells.length - 1 === index)  
                                                              &&  ` right-0 sticky border-l px-4 border-gray   
                                                              ${(viewPosition?.position_number !==undefined 
                                                                && row?.original?.position_number 
                                                                === viewPosition?.position_number) 
                                                                                ? "bg-lighestgray " : "bg-white "}  ` ) 
                                                                + (row.cells.length - 1 === index && " ") ))
                                                                    }
                                                                >
                                                                    { col?.accessor(nestedRow) }
                                                                    <div
                                                                        className={
                                                                            "border-[#CED0D6] absolute top-0 h-fill-available" +
                                                            (isStickyColumns === true
                                                                ? index === 0
                                                                    ? " border-r right-0 "
                                                                    : row.cells.length - 1 === index
                                                                        ? " border-l left-0 "
                                                                        : ""
                                                                : "")
                                                                        }
                                                                    ></div>
                                                                </td>
                                                                
                                                                
                                                            )) }
                                                        </tr>
                                                    )) } 
                                                        
                                                 
                                                </>
                                            ) }

                                        </>
                                    )
                                }) }
                            </tbody>
                        ) }
                    </table>
                </div> }
            </div>
        </>
    )
}

export default Table
